import IntTypes from './int-types.js';
import PixelTypes from './pixel-types.js';
class ImageType {
    dimension;
    componentType;
    pixelType;
    components;
    constructor(dimension = 2, componentType = IntTypes.UInt8, pixelType = PixelTypes.Scalar, components = 1) {
        this.dimension = dimension;
        this.componentType = componentType;
        this.pixelType = pixelType;
        this.components = components;
    }
}
export default ImageType;
//# sourceMappingURL=image-type.js.map